import { render, staticRenderFns } from "./CustomPickupInfoPanel.vue?vue&type=template&id=5b306a9e&scoped=true&"
import script from "./CustomPickupInfoPanel.vue?vue&type=script&lang=js&"
export * from "./CustomPickupInfoPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b306a9e",
  null
  
)

export default component.exports